import React, { useEffect, useRef } from "react";
import type { NextPage } from "next";
import { useRouter } from "next/router";
import { ReactSVG } from "react-svg";
import loading from "../styles/loadingscreen.module.scss";
import Head from "next/head";

const Loading: NextPage = () => {
  const router = useRouter();
  const hasRedirected = useRef(false);

  useEffect(() => {
    // Prevent multiple redirects
    if (hasRedirected.current) return;

    const timeoutId = setTimeout(() => {
      if (router.pathname === "/" && !hasRedirected.current) {
        hasRedirected.current = true;
        // Use replace instead of push to avoid adding to history stack
        // Navigate to clean /sign-in path without tracking parameters
        router.replace("/sign-in");
      }
    }, 3000);

    return () => clearTimeout(timeoutId);
  }, [router.pathname]);

  return (
    <>
      <Head>
        <title>SellSmart</title>
        <meta
          httpEquiv="cache-control"
          content="no-cache, no-store, must-revalidate"
        />
      </Head>
      <div className={loading.loading_container}>
        <div className={loading.dots_container}>
          <ReactSVG
            src={"/icons/loadingicon.svg"}
            beforeInjection={(svg) => {
              svg.setAttribute("style", "width: 126px;height: 116px;");
            }}
          />
          <div className="snippet" data-title=".dot-flashing">
            <div className={loading.stage}>
              <div className={loading.dot_flashing}></div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Loading;
